import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AlertController, LoadingController, ModalController, ToastController } from '@ionic/angular';
import { BaseClass } from '../../classes/base';
import { TranslationService } from '../../services/translation.service';
import { UtilService } from '../../services/util.service';
import { Goal } from 'src/app/goals/_interfaces/goal.interface';
import { Version } from 'src/app/processes/_interfaces/version.interface';
import { ProcessesService } from 'src/app/processes/processes.service';

@Component({
    selector: 'app-process-config-modal',
    templateUrl: './process-config-modal.component.html',
    styleUrls: ['./process-config-modal.component.scss']
})
export class ProcessConfigModalComponent extends BaseClass implements OnInit {

    @Input() language: string;
    @Input() versionId: number;
    @Input() version: Version;
    @Input() isSelection: boolean = false;

    public goals: Array<Goal> = [];
    public displayedGoals: Array<Goal> = [];
    public selectedLanguage: string;
    private _loading: HTMLIonLoadingElement;

    constructor(
            protected _toastController: ToastController,
            protected _translationService: TranslationService,
            public alertController: AlertController,
            private _loadingController: LoadingController,
            private _modalController: ModalController,
            private _router: Router,
            private _utilService: UtilService,
            private _processesService: ProcessesService,
    ) {
        super(_toastController, _translationService);
    }

    async ngOnInit() {
        this.selectedLanguage = this._translationService.getSelectedLanguage();
        this._loading = await this._loadingController.create({});
    }

    public goBack(): void {
        this._utilService.removeProcessIdFromLocalStorage();
        this._router.navigate(['dashboard']);
    }

    ionViewDidLeave() {
        this._utilService.removeProcessIdFromLocalStorage();
    }

    public changeSelectedLanguage(language: 'pt-BR' | 'en-US' | 'es-ES'): void {
        this.selectedLanguage = language;
    }

    public async saveVersionConfig(isSelectionProcess: boolean = false): Promise<void> {
        await this._loading.present();
        const validationVersionConfig = this.version;
        let success = false;
        if (this.version.id === 0) {
            this._processesService.addValidationProcessConfig(validationVersionConfig, isSelectionProcess).subscribe(async (res) => {
                success = res ? res.success:false;
                await this._loading.dismiss();
                this.dismissModal(success);
            }, async (error) => {
                console.log(error);
                await this._loading.dismiss();
            });
        } else {
            this._processesService.updateValidationProcessConfig(validationVersionConfig, isSelectionProcess).subscribe(async (res) => {
                success = res ? res.success:false;
                await this._loading.dismiss();
                this.dismissModal(success);
            }, async (error) => {
                console.log(error);
                await this._loading.dismiss();
            });
        }

    }

    public dismissModal(data: any = null): void {
        this._modalController.dismiss(data);
    }
}